import Simple from "../../../Components/InputFields/Simple";
import PassWord from "../../../Components/InputFields/PassWord";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import Divider from "./Divider";
import SimpleButton from "../../../Components/Buttons/Simple";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getNextFromRedirect,
  getRedirectFromNext,
} from "../../../helper/nextRedirect";
import Back from "./Back";
import { API_BASE_URL } from "../../../config/api";

export default function ContainerSignUpPhone({
  text,
  type,
  signupData,
  setSignupData,
  setStep,
}) {
  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { search } = useLocation();
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const storedRedirect = localStorage.getItem("post_login_redirect");
  const redirectPath = redirectFromNext || storedRedirect;
  const nextForRedirect = nextParam || getNextFromRedirect(redirectPath);
  const hasRedirect = Boolean(redirectPath);
  const signupHref = nextForRedirect
    ? `/SignUp?next=${nextForRedirect}`
    : "/SignUp";
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [invalidData, setInvalidData] = useState(false);
  const [phoneOld, setPhoneOld] = useState(false);

  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const handlePhoneChange = (e) => {
    setSignupData({ ...signupData, phone_number: e.target.value });
    setFieldsRequired(false);
    setInvalidData(false);
    setPhoneOld(false);
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    // Handle sign-in logic here
    if (signupData.phone_number.trim() === "") {
      setFieldsRequired(true);
      return;
    }
    // if phone number is not valid (basic regex check for Iranian phone numbers)(09 followed by 9 digits)
    const phoneRegex = /^09\d{9}$/;
    if (!phoneRegex.test(signupData.phone_number)) {
      setInvalidData(true);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}auth/trader/signup/request-phone-otp/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone_number: signupData.phone_number,
          }),
        },
      );

      const result = await response.json();

      if (
        result.status === "failure" &&
        result.message === "Phone number already exists."
      ) {
        setLoading(false);
        setPhoneOld(true);
        return;
      }
      // if (
      //   result.status === "failure" &&
      //   result.message === "Verification code could not be queued."
      // ) {
      //   setLoading(false);
      //   return;
      // }

      // Check if server responded with error status
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }
      setLoading(false);
      setStep(3);
    } catch (error) {
      setLoading(false);
      console.error("POST request failed:", error);
      return null; // or throw error again if you want
    }
  };

  return (
    <div className="w-full max-w-md bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 m-4 gap-7 flex flex-col border border-zi-blue-light">
      <div className="flex flex-col gap-2 justify-center items-center">
        <img src={logoSrc} alt="لوگو" className="w-14" />
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex justify-between items-center">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>

        <Back onClick={() => setStep(1)} />
      </div>

      <div>
        <form className="flex flex-col gap-5">
          <Simple
            placeholder="شماره تلفن همراه"
            type="tel"
            id="phoneNumber"
            isNumeric={true}
            formValue={signupData.phone_number}
            formOnChange={handlePhoneChange}
          />
          {!loading ? (
            <GradientBlue
              type="submit"
              value="مرحله بعدی"
              onClick={handleSignin}
            />
          ) : (
            <GradientBlue
              isLoader={true}
              type="submit"
              value="دریافت کد یک‌بار مصرف"
              onClick={handleSignin}
            />
          )}
        </form>
        {fieldsRequired && (
          <p className="text-red-500 text-sm font-extralight mt-1">
            لطفا تمامی فیلدها را پر کنید
          </p>
        )}
        {invalidData && (
          <p className="text-red-500 text-sm font-extralight mt-1">
            شماره تلفن همراه وارد شده معتبر نیست
          </p>
        )}
        {phoneOld && (
          <p className="text-red-500 text-sm font-extralight mt-1">
            این شماره تلفن همراه قبلا ثبت نام شده است
          </p>
        )}
      </div>
    </div>
  );
}
